'use strict';

module.exports = {
    SUPERIMPOSE: 'flex-direction: column;display: inline-flex;justify-content: center;text-align: left;vertical-align: middle;',
    SUPERIMPOSE_SUP_SUB: 'line-height: 1; font-size: 70%'
};




// WEBPACK FOOTER //
// ../mf-parser/src/Style.js